"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Tooltip = void 0;
var _reactUtils = require("@cian/react-utils");
var _uiKit = require("@cian/ui-kit");
var React = _interopRequireWildcard(require("react"));
var _TooltipDesktop = require("./TooltipDesktop");
var _TooltipMobile = require("./TooltipMobile");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const Tooltip = _ref => {
  let {
    content,
    title,
    children
  } = _ref;
  const device = (0, _uiKit.useDeviceType)();
  const {
    state: tooltipOpened,
    toggle
  } = (0, _reactUtils.useToggleState)();
  const TooltipComponent = device === 'desktop' ? _TooltipDesktop.TooltipDesktop : _TooltipMobile.TooltipMobile;
  return /*#__PURE__*/React.createElement(TooltipComponent, {
    content: content,
    title: title,
    toggleVisibility: toggle,
    opened: tooltipOpened
  }, children);
};
exports.Tooltip = Tooltip;